import React, { Component } from 'react'

export default class OrderTime extends Component {
  render() {
    const {time} = this.props
    
    return (
      <div className="row passenger-data">
        <div className="col-8 order-time__info">
          {time ? time : <>Еду сейчас</>}
        </div>
        <div className="col-4 order-time">
          <span>Указать время</span>
          <i className="passenger-data__icon time-icon icons">/</i>
        </div>
      </div>
    )
  }
}
